import { gql } from "@apollo/client";
import { CREDIT_FRAGMENT } from "./creditFragment";

const ATTACH_CREDIT_DOCUMENTS = gql`
  ${CREDIT_FRAGMENT}
  mutation AttachCreditDocument($params: AttachCreditDocumentsParams!) {
    attachCreditDocument(params: $params) {
      ...CreditFields
    }
  }
`;

export default ATTACH_CREDIT_DOCUMENTS;
